const getInitialvalues = (filters) => {
  return {
    project_id: filters.project_id || [],
    university_id: filters.university_id || [],
  };
};

export default getInitialvalues;
